import React from 'react';
import { SectionHeading } from './SectionHeading';
import { TestimonialCard } from './TestimonialCard';
import { testimonials } from '../data/salesData';
export function TestimonialsSection() {
  return <section className="border-b border-[var(--line)] bg-[var(--bg)] py-16 sm:py-20" data-id="element-224" data-mp="1n0tz78al9zfe">
      <div className="mx-auto max-w-6xl px-4" data-id="element-225" data-mp="1r1438fetmfrm">
        <SectionHeading eyebrow="❤️ Comunidad" data-id="element-226" data-mp="1qzt08ht79c1k">
          Profes que ya lo usan
        </SectionHeading>

        <div className="mt-10 grid gap-5 sm:grid-cols-2" data-id="element-227" data-mp="1d0jkfj8wojy4">
          {testimonials.map(t => <TestimonialCard key={t.name} testimonial={t} data-id="element-228" data-mp="1i28y76nijbpw" />)}
        </div>
      </div>
    </section>;
}